/* eslint-disable react/no-unused-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import TextField from 'material-ui/TextField'
import OptionsService, { isEmpty, MIN, trim } from '../../services/OptionsService'

export default class Options extends React.Component {
	constructor(props) {
		super(props)

		this.service = new OptionsService()

		this.state = {
			errors: [],
			options: [],
		}

		this.handleChange = (event) => {
			const index = Number(event.target.id)
			const value = event.target.value
			const newState = this.service.change(index, value)
			this.setState(newState)
		}
	}

	componentWillMount() {
		this.update(this.props)
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.history !== nextProps.history) {
			this.service.setPredict(nextProps.history)
		}
		this.update(nextProps)
	}

	getValues(all) {
		return this.state.options
			.map(trim)
			.map((v, i) => v || this.state.predictions[i])
			.filter((v) => all || !isEmpty(v))
	}

	update({ predictions, values }) {
		const newState = this.service.update(values, predictions)
		this.setState(newState)
	}

	validate() {
		const errors = this.getValues(true).map((option, i, arr) => {
			if (isEmpty(option) && (i < MIN || i < arr.length - 1)) {
				return 'You must fill out the option'
			}
			return null
		})
		this.setState({ errors })
		return errors.every((error) => !error)
	}

	render() {
		return (
			<div className="options">
				{this.state.options.map((option, i, arr) =>
					<div className="option" key={i}>
						<TextField
							errorText={this.state.errors[i]}
							floatingLabelFixed={i >= MIN}
							floatingLabelText={`Answer option ${i + 1}`}
							fullWidth
							id={`${i}`}
							onChange={this.handleChange}
							onFocus={(event) => event.target.select()}
							placeholder={i >= MIN && i === arr.length - 1 ? 'Leave blank if not used' : ''}
							value={arr[i] || this.state.predictions[i] || ''}
						/>
					</div>
				)}
			</div>
		)
	}
}

Options.propTypes = {
	history: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
	predictions: PropTypes.arrayOf(PropTypes.string),
	values: PropTypes.arrayOf(PropTypes.string),
}

Options.defaultProps = {
	predictions: [],
	values: [],
}



// WEBPACK FOOTER //
// ./src/components/create/Options.jsx